import React from 'react';

import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalForm,
  VStack,
} from '../../../../core-ui';
import { CurrencyInput } from '../../../uiold';

type FlatFeesTableFooterProps = {
  currency: string;
  feeAmount: number;
  feeName: string;
  isModalOpen: boolean;
  isSaving: boolean;
  onClick: () => void;
  onClose: () => void;
  onFeeAmountChange: (amount: number) => void;
  onFeeNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
};

export function FlatFeesTableFooter(props: FlatFeesTableFooterProps) {
  const {
    currency,
    feeAmount,
    feeName,
    isModalOpen,
    isSaving,
    onClick,
    onClose,
    onFeeAmountChange,
    onFeeNameChange,
    onSubmit,
  } = props;

  return (
    <>
      <Button isFullWidth isSaving={isSaving} onClick={onClick}>
        {t('Add fee')}
      </Button>
      <ModalForm
        title={t('Add fee')}
        isOpen={isModalOpen}
        submitButtonText={t('Add fee')}
        onClose={onClose}
        onSubmit={onSubmit}
      >
        <VStack align="stretch">
          <FormControl>
            <FormLabel>{t('Fee Name')}</FormLabel>
            <Input
              autoFocus={true}
              onChange={onFeeNameChange}
              value={feeName}
            />
          </FormControl>
          <FormControl>
            <FormLabel>{t('Amount')}</FormLabel>
            <CurrencyInput
              accountCurrency={currency}
              onChange={onFeeAmountChange}
              defaultValue={feeAmount}
            />
          </FormControl>
        </VStack>
      </ModalForm>
    </>
  );
}
